import { formatDate } from '@common/paymentsUtils/dateUtils';
import { Box, Paragraph, Text } from '@zillow/constellation-10';
import Calendar from '@common/components/Calendar';

import PontoonConstants from '@common/constants/PontoonExceptionConstants';

interface Props {
  dueDate: string;
}

const OverdueSchedulingPage = ({ dueDate }: Props) => {
  return (
    <>
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'token(spacing.sm)' }}>
        <Calendar
          title="Pay on"
          dateLine1={formatDate(dueDate, 'MMM do', PontoonConstants.RENTER_HUB.PAYMENTS_SETTINGS.RENT_PAYMENT.DUE_DATE)}
        />
        <Paragraph textStyle="body-sm" css={{ color: 'red.500' }}>
          Your rent payment is overdue.
        </Paragraph>
      </Box>
      <Box css={{ marginTop: 'token(spacing.xs) !important' }}>
        <Text textStyle="body-sm">
          Your payment will be processed immediately. If this date falls on a weekend or holiday, we&apos;ll send the
          rent&nbsp;
        </Text>
        <Text textStyle="body-sm-bold">1 business day later. &nbsp;</Text>
      </Box>
    </>
  );
};

export default OverdueSchedulingPage;
